const index = {
    state: {
        customer_type: "customer",
        campaign_type: "campaign",
        inventory_type: "inventory",
        /*customerAgreementType:*/
        userId: null,
        curl: "",
        rurl: "",
        id: null,
        addresses: [],
        address: {}
    },

    getters: {
    },

    mutations: {
        update_customer_type(state, payload) { state.customer_type = payload; },
        updateUserId(state, payload) { state.userId = payload; },
        updateCurl(state, payload) { state.curl = payload; },
        updateRurl(state, payload) { state.rurl = payload; },
        set_addresses(state, payload) { state.addresses = payload; },
        set_address(state, payload) { state.address = payload; },
        add_address(state, payload) { state.addresses.push(payload); },
        update_address(state, payload) {
            let idx = state.addresses.findIndex(address => address.id == payload.address.id);
            state.addresses[idx] = payload;
        },
        updateId(state, payload) {
            state.id = payload;
        },
        remove_address(state, payload) {
            let idx = state.addresses.findIndex(address => address.id = payload);
            state.addresses.splice(idx, 1);
        },
    },

    actions: {

    }
}

export default index;

